import React, { useEffect, useState } from "react";
import { useCompactListLayout } from "@/utils/hooks/useCompactListLayout";
import NoDataAvailable from "@/components/cards/NoDataAvailable";
import { AddUserTableSkeletonDesktop, AddUserTableSkeletonMobile } from "@/components/skeletons";
import { fetchADUsers } from "@/services/user.service";
import { useDataQueries } from "@/utils/hooks/useDataQueries";
import SearchBar from "@/components/navbars/SearchBar";

interface AddUserTableProps {
    handleUserSelect: (user: any) => void;
    selectedUsers: any;
    setSelectedUsers: any;
    handleSelectAll: (users: any[]) => void;
    isSelectAll: boolean;
    tab: string;
}

const AddUserTable = (props: AddUserTableProps) => {
    const isCompactLayout = useCompactListLayout();
    const [isLoading, setIsLoading] = useState(false);
    const [allFetched, setAllFetched] = useState(false);
    const [dataLoad, setDataLoad] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [pageNo, setPageNo, dataLength, setDataLength, sorting, setSorting, filter, setFilter, searchItem, setSearchItem, resetDataQueries] = useDataQueries();
    const [ADUsers, setADUsers] = useState<any>([]);

    const handleFetchUsers = () => {
        fetchADUsers(pageNo, dataLength, sorting, filter, searchItem,
            (response: any) => { setIsLoading(false); setDataLoad(false); if (response.data?.users?.length < dataLength) setAllFetched(true); setADUsers(response.data.users); },
            (error: any) => { console.log(error); setIsLoading(false); setDataLoad(false); }
        );
    };

    useEffect(() => { setADUsers([]); setPageNo(1); setAllFetched(false); setIsLoading(true); setDataLoad(true); handleFetchUsers(); }, [dataLength, sorting, searchItem]);

    const handleSearch = (searchItem: any) => setSearchItem(searchItem === '' ? null : searchItem);
    const reset = () => { setSearchItem(''); window.scrollTo(0, 0); };

    return (
        <>
            <div className='border-b border-muted p-2'>
                {showSearch ? (
                    <SearchBar id='add-user-table' onHide={() => setShowSearch(false)} handleSearch={handleSearch} reset={reset} title={""} />
                ) : (
                    <div className='flex justify-end'>
                        <button className='p-2 rounded hover:bg-background transition-colors' onClick={() => setShowSearch(true)}>
                            <em className='icon ni ni-search' id='contact-tab-search-icon' />
                        </button>
                    </div>
                )}
            </div>
            {dataLoad ? (
                isCompactLayout ? <AddUserTableSkeletonMobile /> : (
                    <table className="datatable-init w-full" data-auto-responsive="false">
                        <thead>
                            <tr className="">
                                <th className="w-10" />
                                <th className="hidden md:table-cell"><span>Name</span></th>
                                <th className=""><span>Email</span></th>
                            </tr>
                        </thead>
                        <tbody><AddUserTableSkeletonDesktop /></tbody>
                    </table>
                )
            ) : ADUsers.length > 0 ? (
                isCompactLayout ? (
                    <div className="envelope_table">
                        {ADUsers.map((user: any, index: number) => (
                            <div className="envelope_tr" key={index}>
                                <div className="meta my-1">
                                    <label className="flex items-center gap-2 ml-5 cursor-pointer">
                                        <input type={props.tab === 'single' ? 'radio' : 'checkbox'} checked={props.selectedUsers.includes(user)} onChange={() => props.handleUserSelect(user)} />
                                        <span>{user.name}</span>
                                    </label>
                                </div>
                                <div className="env_meta_data">
                                    <div className="tb-lead normal-Text">{user.full_name} {user.groups?.length > 0 && user.groups.map((g: any) => <span key={g.displayName}>{g.displayName} </span>)}</div>
                                    <div className="text-foreground name bold-Text">{user.email_address}</div>
                                    <div className="text-muted-foreground text-xs">{user.phone_number?.length > 3 ? user.phone_number : ''}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <table className="datatable-init w-full" data-auto-responsive="false">
                        <thead>
                            <tr className="">
                                <th className="w-10">
                                    {props.tab !== 'single' && (
                                        <input type="checkbox" checked={props.isSelectAll} onChange={() => props.handleSelectAll(ADUsers)} />
                                    )}
                                </th>
                                <th className="hidden md:table-cell"><span>Name</span></th>
                                <th className=""><span>Email</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {ADUsers.map((user: any, index: number) => (
                                <tr className="" key={index}>
                                    <td className="w-10">
                                        <label className="flex items-center gap-2 cursor-pointer">
                                            <input type={props.tab === 'single' ? 'radio' : 'checkbox'} checked={props.selectedUsers.includes(user)} onChange={() => props.handleUserSelect(user)} />
                                            <span>{user.name}</span>
                                        </label>
                                    </td>
                                    <td className="hidden md:table-cell">
                                        <div className="flex items-center gap-2">
                                            <em className={`icon ni ${user.groups?.length > 0 ? "ni-users" : "ni-user"} fs-6`} />
                                            <span className="tb-lead normal-Text">{user.full_name} {user.groups?.length > 0 && user.groups.map((g: any) => <span key={g.displayName}>{g.displayName} </span>)}</span>
                                        </div>
                                    </td>
                                    <td className="hidden md:table-cell">
                                        <span className="tb-amount normal-Text">{user.email_address}</span>
                                    </td>
                                </tr>
                            ))}
                            {isLoading && <AddUserTableSkeletonDesktop rowCount={2} />}
                        </tbody>
                    </table>
                )
            ) : (
                <NoDataAvailable><p className="center">No Users Available in Your Active Directory</p></NoDataAvailable>
            )}
        </>
    );
};

export default AddUserTable;
